import { IconProps } from "@chakra-ui/react";
import RoundPersonOutline from "./Iconify/RoundPersonOutline";

export default function CaminoNewHireIcon(props: IconProps) {
  return <RoundPersonOutline {...props} />;
}
